import sort, { ESortOrder, dateSort, stringSort } from "@domains/utils/sort";
import { addCommas } from "@domains/utils/numberMethods";
class CommonPresenter {
    constructor(usecase, actions) {
        this.usecase = usecase;
        this.actions = actions;
    }
    getScripDetailData(req) {
        this.actions.scripDetailActions.hideError();
        this.actions.scripDetailActions.startLoader();
        this.usecase.scripDetail.execute({
            onSuccess: (data) => {
                if (data) {
                    this.actions.scripDetailActions.getScripDetailData(data);
                }
                this.actions.scripDetailActions.stopLoader();
            },
            onError: (error) => {
                this.actions.scripDetailActions.setError({ isOpen: true, error });
                this.actions.scripDetailActions.stopLoader();
            },
        }, req);
    }
    getSortedData(data, type, key, dataType) {
        let sortType = type ? ESortOrder.ASC : ESortOrder.DESC;
        if (dataType === "string")
            return stringSort(data, key, sortType);
        else if (dataType === "Date")
            return dateSort(data, key, sortType);
        else if (dataType === "numberWithComma")
            return sort(data.map((x) => {
                if (x[key] === "-" ||
                    x[key] === "" ||
                    x[key] === null ||
                    x[key] === undefined)
                    return x;
                return Object.assign(Object.assign({}, x), { [key]: parseFloat(x[key].replace(/,/g, "")) });
            }), key, sortType).map((x) => {
                return Object.assign(Object.assign({}, x), { [key]: addCommas(x[key]) });
            });
        return sort(data, key, sortType);
    }
    async readConfig() {
        return new Promise((resolve, reject) => {
            this.usecase.customConfig.execute({
                onSuccess: (configuration) => {
                    resolve(configuration);
                },
                onError: (error) => {
                    reject(error);
                },
            }, null);
        });
    }
    returnScriptData(req) {
        return new Promise((res, rej) => {
            this.usecase.scripDetail.execute({
                onSuccess: (data) => {
                    if (data) {
                        res(data);
                    }
                },
                onError: (error) => {
                    rej({ isOpen: true, error });
                },
            }, req);
        });
    }
}
export default CommonPresenter;
